import useAxios from "./useAxios.js";
import { useCallback } from "@wordpress/element";

export function useSearchStores() {
  const [data, execute] = useAxios(
    {
      url: wpApiSettings.root + "manitoba-stores/v1/stores",
    },
    {
      manual: true,
    }
  );

  return [
    data,
    useCallback(
      function (search, max = 10) {
        execute({
          params: { search, max },
        });
      },
      [execute]
    ),
  ];
}
